"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.balanceEpics = void 0;
var _types = require("./types");
var _reduxObservable = require("redux-observable");
var _operators = require("rxjs/operators");
var _rxjs = require("rxjs");
var _actions = require("./actions");
var _actions2 = require("../bet/actions");
var _RoundState = require("../enums/RoundState");
var _types2 = require("../com/types");
var _currencyFormatter = require("../../../utils/currencyFormatter");
var _CommandType = require("../../dovahzul/CommandType");
/**
 * Send format balance action when the balance is changed.
 *
 */
var formatBalanceEpic = function formatBalanceEpic(action$, store) {
  return action$.pipe((0, _reduxObservable.ofType)(_types.UPDATE_BALANCE), (0, _operators.mergeMap)(function (a) {
    var currency = store.value.balance.currency;
    var action = (0, _actions.updateFormattedBalance)({
      balance: {
        formatted: (0, _currencyFormatter.currencyFormatter)(store.value.balance.balance.centValue / 100, currency, store.value.config.locale, undefined, true)
      },
      bonusBalance: {
        formatted: (0, _currencyFormatter.currencyFormatter)(store.value.balance.bonusBalance.centValue / 100, currency, store.value.config.locale, undefined, true)
      }
    });
    return (0, _rxjs.of)(action);
  }));
};

/**
 * Send format balance action when the balance is changed.
 *
 */
var autoAdjustBet = function autoAdjustBet(action$, store) {
  return action$.pipe((0, _reduxObservable.ofType)(_types.UPDATE_BALANCE), (0, _operators.filter)(function () {
    return store.value.balance.balance.centValue < store.value.bet.centValue && store.value.game.roundState == _RoundState.RoundState.Ended && store.value.config.autoAdjustBet && store.value.config.autoAdjustBetAllowed && !store.value.blitz.on &&
    // dont do autoadjust when in blitz, not nice
    !store.value.promotion.on;
  }), (0, _operators.mergeMap)(function () {
    // we only ever adjust denom.
    var betState = store.value.bet;
    var denomIndex = betState.denominations.indexOf(betState.denomination);
    var betToHigh = true;
    while (betToHigh && denomIndex >= 0) {
      denomIndex--;
      if (betState.denominations[denomIndex] * betState.coins * betState.lines * 100 <= store.value.balance.balance.centValue) {
        betToHigh = false;
      }
    }
    if (!betState.denominations[denomIndex]) {
      return _rxjs.EMPTY;
    }
    return (0, _rxjs.of)((0, _actions2.updateBet)({
      denomination: betState.denominations[denomIndex]
    }));
  }));
};
var updateBalanceBet = function updateBalanceBet(action$, store) {
  return action$.pipe((0, _reduxObservable.ofType)(_types.UPDATE_BALANCE_BET), (0, _operators.filter)(function (a) {
    return !store.value.promotion.on && !store.value.config.promoGame;
  }), (0, _operators.mergeMap)(function (a) {
    var currency;
    if (a.payload) {
      currency = a.payload.currency;
    }
    if (!currency) currency = store.value.balance.currency;
    var newbalance = store.value.balance.balance.centValue - store.value.bet.centValue;
    if (newbalance <= 0) newbalance = 0;
    var action = (0, _actions.updateBalance)({
      balance: {
        centValue: newbalance,
        formatted: (0, _currencyFormatter.currencyFormatter)(newbalance / 100, currency, store.value.config.locale)
      }
    });
    return (0, _rxjs.of)(action);
  }));
};
var updateBalanceBetFeatureBuy = function updateBalanceBetFeatureBuy(action$, store) {
  return action$.pipe((0, _reduxObservable.ofType)(_types.UPDATE_BALANCE_BET_FEATURE_BUY), (0, _operators.filter)(function (a) {
    return !store.value.promotion.on && !store.value.config.promoGame;
  }), (0, _operators.mergeMap)(function (a) {
    var currency = store.value.balance.currency;
    var newbalance = store.value.balance.balance.centValue - store.value.bet.centValue * a.payload;
    if (newbalance <= 0) newbalance = 0;
    var action = (0, _actions.updateBalance)({
      balance: {
        centValue: newbalance,
        formatted: (0, _currencyFormatter.currencyFormatter)(newbalance / 100, currency, store.value.config.locale)
      }
    });
    return (0, _rxjs.of)(action);
  }));
};
var commandBalance = function commandBalance(action$, store) {
  return action$.pipe((0, _reduxObservable.ofType)(_types2.COMMAND_PLAY), (0, _operators.filter)(function (a) {
    return _CommandType.CommandType.BalanceResponse === a.payload.type;
  }), (0, _operators.mergeMap)(function (a) {
    var command = a.payload;
    return (0, _rxjs.of)({
      type: _types.UPDATE_BALANCE,
      payload: {
        balance: command.balance,
        bonusBalance: command.bonusBalance,
        currency: command.currency ? command.currency : store.value.balance.currency
      }
    }, {
      type: _types2.COMMAND_QUEUE_NEXT
    });
  }));
};

/**
 * Basically just refreshes it, will trigger a reformat of the balance.
 * Great for currency sign changes etc.
 * 
 * @param action$ 
 * @param store 
 * @returns 
 */
var forceUpdateBalance = function forceUpdateBalance(action$, store) {
  return action$.pipe((0, _reduxObservable.ofType)(_types.UPDATE_BALANCE_FORCE), (0, _operators.mergeMap)(function () {
    return (0, _rxjs.of)({
      type: _types.UPDATE_BALANCE,
      payload: store.value.balance
    });
  }));
};
var balanceEpics = exports.balanceEpics = (0, _reduxObservable.combineEpics)(formatBalanceEpic, updateBalanceBet, autoAdjustBet, commandBalance, updateBalanceBetFeatureBuy, forceUpdateBalance);
//# sourceMappingURL=epics.js.map